import { useState, useEffect } from "react";
import { showSuccessToast } from "../../utils/toasts";
import { authOtpService } from "../../modules/api_client";

export function useOTP() {
  const [isSending, setIsSending] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    if (isResendDisabled && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else if (countdown === 0) {
      setIsResendDisabled(false);
    }
  }, [isResendDisabled, countdown]);

  const sendOTP = async (phone_number: string, isResend = false) => {
    setIsSending(true);

    await authOtpService.otpLoginRequest({
      phoneNumber: phone_number,
    });

    showSuccessToast(
      isResend ? "OTP resent successfully!" : "OTP sent successfully!"
    );
    setOtpSent(true);
    setIsResendDisabled(true);
    setCountdown(30);
    setIsSending(false);
  };

  const confirmOTP = async (otp: string, phone_number: string) => {
    setIsVerifying(true);
    try {
      await authOtpService.otpLoginVerify({ otp, phoneNumber: phone_number });
      showSuccessToast("Phone number verified!");
      return true;
    } catch {
      return false;
    } finally {
      setIsVerifying(false);
    }
  };

  const resetCountdown = () => {
    setCountdown(30);
    setIsResendDisabled(true);
  };

  const resendOTP = async (phone_number: string) => {
    if (isResendDisabled) return;
    await sendOTP(phone_number);
  };

  return {
    sendOTP,
    confirmOTP,
    isSending,
    isVerifying,
    otpSent,
    setOtpSent,
    isResendDisabled,
    resetCountdown,
    countdown,
    resendOTP,
  };
}
